import { SelectItemResponse } from '@src/interface/api/response.interface'
import client from '@src/lib/api/client'
import { stringify } from 'qs'
import type { OrderItem } from '@src/type/order'
import { SelectRequest } from '@src/interface/api/request.interface'

export type ResType = SelectItemResponse<{ order_items?: OrderItem[]; count?: string }>

export type SelectQuery = SelectRequest & {
	status?: string
	showUser?: boolean
	showOrderShipping?: boolean
	showTracking?: boolean
	showOrder?: boolean
	showOrderTossRecord?: boolean
	showOrderItemTracking?: boolean
}
export const getVendorOrderItems = async ({
	status,
	lastPosNo,
	limit,
	offset,
	getTotal,
	showUser,
	showOrderShipping,
	showTracking,
	showOrder,
	showOrderTossRecord,
	showOrderItemTracking,
}: SelectQuery): Promise<ResType> => {
	const queryString = stringify({
		status,
		last_pos_no: lastPosNo,
		limit,
		offset,
		get_total: getTotal,
		show_tracking: showTracking,
		show_user: showUser,
		show_order_shipping: showOrderShipping,
		show_order: showOrder,
		show_order_toss_record: showOrderTossRecord,
		show_order_item_tracking: showOrderItemTracking,
	})
	const response = await client.get<ResType>(`/vendors/orders/items?${queryString}`)

	return response.data
}
